import $ from "expose-loader?exposes=$,jQuery!jquery";

// window.scan.orbitaPluginScriptSource = "https://scanhealthplan.orbita.cloud:8443/chatbot/v2/chat-plugin.js";
// window.scan.orbitaInitializeScriptSource = "https://scanhealthplan.orbita.cloud:8443/oeapi/initialize-chat.js";

if (window.scan && window.scan.useChatbotPreviousVersion) {
    if (window.scan.renderChatbot && window.scan.orbitaPluginScriptSource && window.scan.orbitaInitializeScriptSource) {
        $(function () {
            var script1 = document.createElement("script");
            script1.type = "text/javascript";
            script1.src = window.scan.orbitaPluginScriptSource;
            document.head.appendChild(script1);

            var script2 = document.createElement("script");
            script2.type = "text/javascript";
            script2.src = window.scan.orbitaInitializeScriptSource;
            document.head.appendChild(script2);
        });
    }
}

if (window.scan && !window.scan.useChatbotPreviousVersion) {
    if (window.scan.renderChatbot && window.scan.orbitaPluginScriptSource && window.scan.orbitaInitializeScriptSource) {
        $(function () {
            $.getScript(window.scan.orbitaPluginScriptSource, function (response, status) {
                $.getScript(window.scan.orbitaInitializeScriptSource, function (response, status) {

                });
            });
        });
    }
}
